'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const react = require('@emotion/react');
const components_display_Spinner_Spinner = require('../../display/Spinner/Spinner.cjs.js');
const components_navigation_Button_Button = require('../Button/Button.cjs.js');
const styleMixins_reset = require('../../../style-mixins/reset.cjs.js');

const LoadMoreBar = (props) => {
  const { children, isLoading, onClick, size } = props;
  const spinner = react.jsx(
    "span",
    { css: Object.assign({ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", gap: "var(--zds-space-12)" }, styleMixins_reset.boxSizing), "data-zds": true },
    react.jsx(components_display_Spinner_Spinner.Spinner, { color: "dark", "aria-label": "Loading icon" }),
    "Loading"
  );
  return react.jsx(components_navigation_Button_Button.Button, { color: "secondary", disabled: isLoading, isFullWidth: true, onClick, size }, isLoading ? spinner : children);
};

exports.LoadMoreBar = LoadMoreBar;
//# sourceMappingURL=LoadMoreBar.cjs.js.map
